import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const PURCHASES = ['Alejandro de Buenos Aires', 'María de Córdoba', 'Fernando de Rosario', 'Carolina de Mendoza', 'Pablo de Tucumán', 'Sofía de Mar del Plata', 'Nicolás de Salta', 'Camila de La Plata', 'Matías de Santa Fe', 'Florencia de Neuquén'];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 4000);
    }, 8000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(cycleInterval);
    };
  }, []);
  return <AnimatePresence data-id="element-201">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-4 left-4 z-40 bg-gray-900 rounded-lg shadow-2xl border border-gray-700 p-3 max-w-sm flex items-start gap-3" data-id="element-202">
          <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 text-gray-500 hover:text-gray-300" data-id="element-203">
            <X className="w-4 h-4" data-id="element-204" />
          </button>

          <div className="mt-1" data-id="element-205">
            <CheckCircle2 className="w-5 h-5 text-[#8FF650]" data-id="element-206" />
          </div>

          <div className="pr-4" data-id="element-207">
            <p className="text-sm font-bold text-white" data-id="element-208">
              {PURCHASES[currentIndex]}
            </p>
            <p className="text-xs text-gray-400 mt-0.5" data-id="element-209">
              acaba de comprar la Biblioteca
            </p>
            <p className="text-xs text-[#8FF650] font-semibold mt-0.5" data-id="element-210">
              Hace unos segundos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}